/* src/app/components/shared/header/header.component.scss */
.midHeader {
  position: fixed;
  width: 100%;
  z-index: 100;
  top: 37px;
}
.midHeader .mt {
  margin-top: 30px;
}
.midHeader1 {
  position: fixed;
  width: 100%;
  z-index: 100;
  top: 0;
}
.midHeader1 .mt {
  margin-top: 0px;
}
.margin-img {
  margin: 0px !important;
}
.width-img {
  width: 60px !important;
}
.line_space {
  line-height: 35px;
  padding: 0;
  padding-bottom: var(--spacing-medium);
  margin-top: var(--spacing-unit);
}
.btn {
  background: transparent;
  color: white;
  border: none;
  cursor: pointer;
}
.p-0 {
  padding: 0px !important;
}
.logo {
  width: 60px !important;
  letter-spacing: normal;
  font-size: 24px;
  font-weight: 700;
  font-family: "IBM Plex Sans", sans-serif;
}
@media only screen and (max-width: 600px) {
  .p-l {
    padding-left: 115px;
  }
  .p-r-10 {
    padding-right: 10px !important;
  }
}
.avtar img {
  height: 32px !important;
  width: 32px !important;
}
.swalImg {
  margin-left: 70%;
  margin-top: -10%;
}
.swal {
  margin-top: 3%;
  width: 225px;
  height: 220px;
}
.text-uppercase {
  text-transform: uppercase;
}
.nocursor {
  cursor: none;
}
.logButton {
  color: #FFFFFF;
  width: 80%;
  font-size: 14px;
  padding: 12px;
  text-align: center;
  border-radius: 40px;
}
.noColor {
  background-color: transparent;
  padding: 13px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.p-r-0 {
  padding-right: 0px;
}
.backOfficeLogo {
  padding: 0px;
  color: white;
}
.p-0-10 {
  padding: 0px 10px;
}
.h-90 {
  height: 90px !important;
}
.f-s-40 {
  font-size: 40px !important;
}
.home-person-logo {
  padding: 0;
}
mat-icon {
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
mat-icon:hover {
  background-color: rgba(0, 0, 0, 0.068);
  border-radius: 50%;
}
@media (max-width: 480px) {
  .midHeader {
    top: 70px;
    height: 80px !important;
  }
}
.menu-items {
  margin: 0 20px;
}
.menu-items span,
.menu-items a {
  color: #363636;
  font: 405 18px Poppins;
  margin-bottom: 8px;
  cursor: pointer;
}
@media (min-width: 481px) and (max-width: 600px) {
  .home-header .cart-count-wrapper {
    left: 37px !important;
  }
}
.f-w-100 {
  font-weight: 900;
}
.heading span,
#header-menu span {
  cursor: pointer;
  font-family: "IBM Plex Sans", sans-serif;
}
.heading span:hover,
#header-menu span:hover {
  opacity: 0.8;
}
.wh-40 {
  height: 40px !important;
  width: 40px !important;
}
.mat-hover:hover {
  background-color: rgba(0, 0, 0, 0.068);
}
.mat-hovers:hover {
  background-color: rgba(240, 240, 240, 0.068);
}
.bgm-grey {
  background-color: rgba(0, 0, 0, 0.068);
  border-radius: 23px;
}
.p-width {
  margin-top: 37px;
}
.p-width2 {
  margin-top: 7px;
}
.h-52 {
  height: 52px;
}
.text-gray {
  color: var(--theme-selected-state) !important;
}
.home-header .mat-mdc-menu-content {
  width: 100% !important;
}
.display-inline-relative {
  display: inline;
  position: relative;
  top: 8px;
  left: 2%;
}
.product-button {
  margin: 10px;
  padding: 2px 12px !important;
  background-color: black !important;
  color: white !important;
  width: 20%;
}
.shop-btn {
  background: white;
  display: inline-block;
  cursor: pointer;
}
.w-60 {
  width: 60%;
}
.receipt {
  left: 10%;
  margin-top: -8%;
}
.receiptOrder {
  margin-top: 7%;
}
/*# sourceMappingURL=header.component.css.map */
